<template>
  <div class="structured-description__head container-inner">
    <div class="structured-description__menu">
      <MainLogo />

      <div class="structured-description__menu-links">
        <router-link-modified
          v-for="(headerLink, index) in headerLinks"
          :key="index"
          class="base-link employers-lt-page-header__menu-link"
          :to="headerLink.url"
        >
          <BaseSvg
            :name="headerLink.icon.name"
            :width="headerLink.icon.width"
            :height="headerLink.icon.height"
            class="base-link__ico"
          />
          <span class="base-link__text">{{ headerLink.title }}</span>
        </router-link-modified>

        <BaseMenu
          fixed-on-page
        >
          <template v-slot:activator="{ on }">
            <div
              class="structured-description__burger-menu"
              v-on="on"
            >
              <BaseSvg
                name="ico-burger"
                width="2.1rem"
                height="1.5rem"
              />
            </div>
          </template>

          <div class="d-flex flex-column">
            <router-link-modified
              v-for="(headerLink, index) in headerLinks"
              :key="index"
              class="base-link employers-lt-page-header__menu-link"
              :class="{ 'mb-5': index < headerLinks.length - 1 }"
              :to="headerLink.url"
            >
              <BaseSvg
                :name="headerLink.icon.name"
                :width="headerLink.icon.width"
                :height="headerLink.icon.height"
                class="base-link__ico"
              />
              <span class="base-link__text">{{ headerLink.title }}</span>
            </router-link-modified>
          </div>
        </BaseMenu>
      </div>
    </div>

    <div class="structured-description__hero">
      <div class="structured-description__hero-desc">
        <h1 class="structured-description__title">{{ sectionBlock.labels[0] }}</h1>
        <div class="structured-description__head-text">
          {{ sectionBlock.labels[1] }}
        </div>
        <div class="structured-description__activate-btn-footer justify-flex-start mt-15">
          <a
            v-if="sectionCustomBtnAction"
            :href="sectionBlock.button.url"
            class="base-btn base-btn--green _top-section-btn"
            @click.prevent="sectionCustomBtnAction"
          >
            {{ sectionBlock.button.text }}
          </a>
          <router-link-modified
            v-else
            class="base-btn base-btn--green _top-section-btn"
            :to="sectionBlock.button.url"
          >
            {{ sectionBlock.button.text }}
          </router-link-modified>
        </div>
      </div>

      <div class="structured-description__hero-img">
        <img :src="sectionBlock.images.image_pc" alt="">
      </div>

      <div class="structured-description__hero-offer">
        <div class="structured-description__hero-offer-date">{{ sectionBlock.labels[2] }}</div>
        <div class="structured-description__hero-offer-desc">{{ sectionBlock.labels[3] }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import MainLogo from '../MainLogo.vue';

export default {
  name: 'StructuredDescriptionTopSection',
  components: {
    MainLogo,
  },
  props: {
    headerLinks: {
      type: Array,
      default: () => [],
    },
    sectionBlock: {
      type: Object,
      required: true,
    },
    sectionCustomBtnAction: {
      type: Function,
      default: null,
    },
  },
};
</script>
